/** @format */
import { rgba } from 'emotion-rgba';
import { css } from 'styled-components';

import { smallTablet } from '@toucan/client/global/application';

import { SearchFilterMenuOptionListState } from './types';

/* eslint-disable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */
const baseStyles = css`
    position: relative;
    display: flex;
    flex-direction: column;
    min-height: 0;

    ul {
        max-height: 25rem;
        overflow-y: auto;
        padding: 0 var(--layout-spacing-24);
        margin: var(--layout-spacing-12) 0 0;

        &:active,
        &:focus {
            outline: 0;
        }

        &:-moz-focusring {
            text-shadow: 0 0 0 #000;
        }

        li {
            list-style: none;
            padding: var(--layout-spacing-4) 0;

            .choice {
                margin-bottom: 0.1rem;
            }

            &[data-active='true'] {
                background: ${rgba('#0b002b', 0.1)};

                input ~ label {
                    font-weight: 600;
                }
            }

            &[data-active='false'] {
                input,
                label {
                    cursor: default;
                }
            }

            input[disabled],
            input[disabled] ~ label {
                opacity: 0.6;
            }

            label {
                width: 100%;
                font-size: 1.2rem;
            }
        }
    }

    &:after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        right: var(--layout-spacing-24);
        height: 7.2rem;
        background: linear-gradient(0deg, white 0%, ${rgba('white', 0)} 100%);
        pointer-events: none;
        z-index: 100;
        transition: opacity 140ms linear;
        opacity: 1;
    }

    ${smallTablet(css`
        ul {
            padding: 0;
            margin: -0.6rem 0 0;
            max-height: initial;
            overflow-y: initial;

            li {
                padding: 0.6rem 0;

                &[data-active='true'] {
                    background: initial;

                    input ~ label {
                        font-weight: unset;
                    }
                }

                .choice {
                    margin-bottom: 0;
                }
            }
        }

        &:after {
            display: none;
        }
    `)}
`;
/* eslint-enable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */

const scrollStyles = ({ atScrollEnd }: SearchFilterMenuOptionListState) => {
    if (!atScrollEnd) {
        return css``;
    }
    return css`
        &:after {
            opacity: 0;
        }
    `;
};

export const styles = (props: SearchFilterMenuOptionListState) => css`
    ${baseStyles}
    ${scrollStyles(props)}
`;
